import douglas from "../../images/crew/image-douglas-hurley.webp";
import mark from "../../images/crew/image-mark-shuttleworth.png";
import victor from "../../images/crew/image-victor-glover.png";
import anousheh from "../../images/crew/image-anousheh-ansari.png";

export const data = [
  {
    title: "commander",
    name: "Douglas Hurley",
    text: "Douglas Gerald Hurley is an American engineer, former Marine Corps pilot and former NASA astronaut. He launched into space for the third time as commander of Crew Dragon Demo-2.",
    img: `${douglas}`,
  },
  {
    title: "mission specialist",
    name: "Mark Shuttleworth",
    text: "Mark Richard Shuttleworth is the founder and CEO of Canonical, the company behind the Linux-based Ubuntu operating system. Shuttleworth became the first South African to travel to space as a space tourist.",
    img: `${mark}`,
  },
  {
    title: "pilot",
    name: "Victor Glover",
    text: "Pilot on the first operational flight of the SpaceX Crew Dragon to the International Space Station. Glover is a commander in the U.S. Navy where he pilots an F/A-18.He was a crew member of Expedition 64, and served as a station systems flight engineer. ",
    img: `${victor}`,
  },
  {
    title: "flight engineer",
    name: "Anousheh Ansari",
    text: "Anousheh Ansari is an Iranian American engineer and co-founder of Prodea Systems. Ansari was the fourth self-funded space tourist, the first self-funded woman to fly to the ISS, and the first Iranian in space.",
    img: `${anousheh}`,
  },
];
